import PropTypes from 'prop-types'
import React from 'react'

// Vendored from @tabler/icons-react (MIT, https://tabler.io/icons) so we
// don't carry the full library for a handful of icons
const IconReceiptDollar = ({ className, color, size, strokeWidth }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2" />
    <path d="M14.8 8a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
    <path d="M12 6v10" />
  </svg>
)

IconReceiptDollar.defaultProps = {
  className: '',
  color: 'currentColor',
  size: 24,
  strokeWidth: 2,
}

IconReceiptDollar.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
}

export default IconReceiptDollar
